import { useClient } from '@composables/use-clients';
import {
  PostRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PostTeamTagPayloadType = {
  displayName: string;
};

export type PostTeamTagArgsType = PostRequestArgsType<PostTeamTagPayloadType> & {
  teamCode: string;
};

export type DeleteTeamTagArgsType = DeleteRequestArgsType & {
  teamCode: string;
  teamTagId: number;
};

export const apiCreateTeamTag = async ({
  domain = useTenantStore().domain,
  teamCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostTeamTagArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.teamTags({ domain, teamCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteTeamTag = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamTagId,
  errorConfig = {},
  callbacks = {},
}: DeleteTeamTagArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.teamTags({ domain, teamCode, teamTagId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
